import { APICore } from 'helpers/api/apiCore'

const api = new APICore()

export function getPropostasJaContratadas() {
  return api.get(`Propostas/propostas`, null)
}
